import { Database, Cloud, Code2, BarChart3 } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useT } from "../i18n/useT";

// Tech names stay the same in both locales; only the group titles translate.
const groupItems = {
  data: ["Kafka", "Flink", "Airflow", "dbt", "Snowflake", "Parquet", "Iceberg"],
  cloud: ["AWS", "Kubernetes", "Docker", "Terraform", "GitLab CI/CD", "Observability"],
  backend: ["Python", "Java", "REST APIs", "Microservices", "System integration"],
  analytics: ["SQL", "Data modelling", "Dashboards", "Reporting platforms"],
} as const;

const groupIcons = {
  data: Database,
  cloud: Cloud,
  backend: Code2,
  analytics: BarChart3,
} as const;

export default function Expertise() {
  const t = useT();
  const groupKeys: (keyof typeof groupItems)[] = ["data", "cloud", "backend", "analytics"];
  return (
    <section id="expertise" className="py-24 sm:py-28 border-t border-ink-800/60">
      <div className="container-page">
        <SectionHeading
          eyebrow={t.expertise.eyebrow}
          title={t.expertise.title}
          lede={t.expertise.lede}
        />
        <div className="mt-12 grid gap-4 sm:grid-cols-2">
          {groupKeys.map((k) => {
            const Icon = groupIcons[k];
            return (
              <div
                key={k}
                className="rounded-xl border border-ink-800 bg-ink-900/40 p-6"
              >
                <div className="flex items-center gap-3">
                  <Icon className="size-5 text-accent-500" />
                  <h3 className="text-base font-semibold text-ink-50">
                    {t.expertise.groups[k]}
                  </h3>
                </div>
                <ul className="mt-4 flex flex-wrap gap-2">
                  {groupItems[k].map((it) => (
                    <li
                      key={it}
                      className="rounded-md border border-ink-800 bg-ink-950/60 px-2.5 py-1 font-mono text-xs text-ink-200"
                    >
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
